import { useState, useEffect } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import { getTransactionsAggregate } from 'api';

export default function usePartnersTable({ env, startedFrom, finishedTo }) {
  const token = useAuthHeader()();

  const [tableData, setTableData] = useState({});
  const [totalPaymentCount, setTotalPaymentCount] = useState(0);
  const [totalPayoutCount, setTotalPayoutCount] = useState(0);

  useEffect(() => {
    const updateTableData = async (startedFrom, finishedTo) => {
      const data = await getTransactionsAggregate({
        env,
        token,
        started: startedFrom,
        finished: finishedTo,
        groupBy: 'partner_id,type,status',
      });

      let totalPaymentCount = 0;
      let totalPayoutCount = 0;

      const result = data.reduce((accum, item) => {
        if (!accum[item.partner_id]) {
          accum[item.partner_id] = {
            paymentCount: 0,
            chargedPaymentCount: 0,
            payoutCount: 0,
            chargedPayoutCount: 0,
          };
        }

        if (item.type === 'payment') {
          accum[item.partner_id].paymentCount =
            accum[item.partner_id].paymentCount + item.count;
          totalPaymentCount = totalPaymentCount + item.count;

          if (item.status === 'Charged') {
            accum[item.partner_id].chargedPaymentCount =
              accum[item.partner_id].chargedPaymentCount + item.count;
          }
        }

        if (item.type === 'payout') {
          accum[item.partner_id].payoutCount =
            accum[item.partner_id].payoutCount + item.count;
          totalPayoutCount = totalPayoutCount + item.count;

          if (item.status === 'Charged') {
            accum[item.partner_id].chargedPayoutCount =
              accum[item.partner_id].chargedPayoutCount + item.count;
          }
        }

        return accum;
      }, {});

      setTableData(result);
      setTotalPaymentCount(totalPaymentCount);
      setTotalPayoutCount(totalPayoutCount);
    };

    updateTableData(startedFrom, finishedTo);
  }, [startedFrom, finishedTo, token, env]);

  return { tableData, totalPaymentCount, totalPayoutCount };
}
